export const SEARCH_SPLIT_REGEX = /[-‑,\s]+/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#@$%*()\-/:?{}~!"^_`\[\]]).{8,}$/;

export const VERSE_REGEX = /^\d+:\d+$/;
